import React, { useEffect, useState } from 'react'
import "./changemembership.scss"
import { getAccountInfo, updateSubscription } from '../../Api';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

function ChangeMembership() {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('monthly');
    const [userData, setUserData] = useState(null);

    const getPriceId = (planVal, planType) => {
        if(planVal === 'Test' && planType === 'Monthly'){
            return "price_1PrCaqGJGsgTzboDhvFKWJCL"
        }else if(planVal === 'Test' && planType === 'Yearly'){
            return "price_1PrCcYGJGsgTzboDEK70kVoN"
        }else if(planVal === 'Starter' && planType === 'Monthly'){
            return "price_1Q8gnlGJGsgTzboDEkjLxU5f"
        }else if(planVal === 'Starter' && planType === 'Yearly'){
            return "price_1Q8grSGJGsgTzboDOLP7H7qK"
        }else if(planVal === 'Professional' && planType === 'Monthly'){
            return "price_1Q8gswGJGsgTzboDlBxWpGU9"
        }else if(planVal === 'Professional' && planType === 'Yearly'){
            return "price_1Q8guVGJGsgTzboDkLQmayo6"
        }else if(planVal === 'Enterprise' && planType === 'Monthly'){
            return "price_1Q8gswGJGsgTzboDlBxWpGU9"
        }else if(planVal === 'Enterprise' && planType === 'Yearly'){
            return "price_1Q8guVGJGsgTzboDkLQmayo6"
        }else {
            return "";
        }
    }

    const upgradePlan = async (plan, type) => {
        Swal.fire({
            html: `<img src='/circle-1700_256.gif' style="height: 60px" alt="" />`,
            customClass: { popup: 'loader' },
            showConfirmButton: false,
            heightAuto: false
        })
        
            let data = {
                old_price_id: getPriceId(userData.plan, userData.subscription_type),
                new_price_id: getPriceId(plan, type),
                subscriptionId: userData.subscription_id
            }
            // console.log(data);
            let res = await updateSubscription(data);
            if (res && res.status === 'S') {
                Swal.fire({
                    text: 'Membership updated successfully!',
                    icon: 'success',
                    iconColor: '#000',
                    showConfirmButton: false,
                    heightAuto: false,
                }).then(() => {
                  navigate('/dashboard')
                });
            }else {
                // Swal.fire({
                //     text: 'Something went wrong!',
                //     icon: 'warning',
                //     iconColor: '#000',
                //     showConfirmButton: false,
                //     heightAuto: false
                // });
                Swal.close()
            }
    }

    useEffect(() => {
        (async () => {
            Swal.fire({
              html: `<img src='/circle-1700_256.gif' style="height: 60px" alt="" />`,
              customClass: { popup: 'loader' },
              showConfirmButton: false,
              heightAuto: false
            })
            let userInfo = JSON.parse(localStorage.getItem('userData') || '{}')
            let response = await getAccountInfo(userInfo.correl_id);
            if (response.status === 'S') {
                setUserData(response.result_info);
                localStorage.setItem('userData', JSON.stringify(response.result_info));
                Swal.close()
            } else {
                Swal.close()
            }
        })()
    }, [])

    return (
      <div className='pricing-page'>
      <div className="pricingContainer">
          <h5 className='pricing-heading mb-4'>Change Membership</h5>
          {userData && <div className="row g-3">
              <div className="col-12">
                <section className='p-0'>
                  <div className="container-fluid">
                  <div className="d-flex align-items-center justify-content-center">
                              <button
                                  className={`tab-button ${activeTab === 'monthly' ? 'active' : ''}`}
                                  onClick={() => setActiveTab('monthly')}
                              >
                                  Monthly
                              </button>
                              <button
                                  className={`tab-button ${activeTab === 'yearly' ? 'active' : ''}`}
                                  onClick={() => setActiveTab('yearly')}
                              >
                                  Yearly ( 24% OFF )
                              </button>

                          </div>
                          <div className="tab-content">
                              {activeTab === 'monthly' && (
                                  <div className="tab-pane-content">
                                      <div className="w-100">
                                          <div className="row justify-content-center">
                                              <div className="col-12 col-lg-4 mb-lg-0 mb-3" >
                                                  <div className="tab-card h-100">
                                                      <div className="tab-side-banner">
                                                          <p className='mb-0'>7-day FREE trial</p>
                                                      </div>
                                                      <div className="text-center px-lg-2">
                                                          <img src={require('../../assets/user.png')} alt="" />
                                                          <p className='mb-0 start-up'>Starter</p>
                                                          <p className='tabcard-description'>Perfect for startups and small businesses aiming to build credibility and enhance their market position through customer testimonials</p>
                                                             {userData && userData.plan === 'Starter' && userData.subscription_type === 'Monthly' && <button className="btn color-btn active-plan">
                                                                  Active
                                                              </button>}
                                                             {userData && !(userData.plan === 'Starter' && userData.subscription_type === 'Monthly') && <button className="btn color-btn" onClick={() => {upgradePlan('Starter', 'Monthly')}}>
                                                                  Start Free Trial
                                                              </button>}
                                                          <p className='mb-0 yearly'><span className='dollar-count'>$ 49</span> /Monthly</p>
                                                      </div>
                                                      <div className="divider">
                                                          <img src={require('../../assets/line-1.png')} alt="" />
                                                          <span className="divider-text">Main Features</span>
                                                          <img src={require('../../assets/line-1.1.png')} alt="" />
                                                      </div>
                                                      <div className="main-content">
                                                          <ul className='list-style'>
                                                              <li className='text-center'>
                                                                  <p>100 Invites/mo</p>
                                                              </li>
                                                              <li className='text-center'>
                                                                  <p>Unlimited Email credits/mo</p>
                                                              </li>
                                                              <li className='text-center'>
                                                                  <p>Automated review collection</p>
                                                              </li>
                                                              <li className='text-center'>
                                                                  <p>3 Channels</p>
                                                              </li>
                                                              <li className='text-center'>
                                                                  <p>Multi-step review campaigns</p>
                                                              </li>
                                                              <li className='text-center'>
                                                                  <p>Review widgets</p>
                                                              </li>
                                                              <li className='text-center'>
                                                                  <p>All review collection tools</p>
                                                              </li>
                                                              <li className='text-center'>
                                                                  <p>Standard support</p>
                                                              </li>
                                                          </ul>
                                                      </div>
                                                  </div>
                                              </div>
                                              <div className="col-12 col-lg-4 mb-lg-0 mb-3">
                                                  <div className="tab-card second-card h-100">
                                                      <div className="tab-side-banner">
                                                          <p className='mb-0'>7-day FREE trial</p>
                                                      </div>
                                                      {/* </Link> */}
                                                      <div className="text-center px-lg-2">
                                                          <img src={require('../../assets/rocket.png')} alt="" />
                                                          <p className='mb-0 start-up'>Professional</p>
                                                          <p className='tabcard-description'>Perfect for organizations aiming to harness cutting-edge review management capabilities to drive customer loyalty and business growth</p>
                                                              {userData && userData.plan === 'Professional' && userData.subscription_type === 'Monthly' && <button className="btn color-btn active-plan">
                                                                  Active
                                                              </button>}
                                                             {userData && !(userData.plan === 'Professional' && userData.subscription_type === 'Monthly') && <button className="btn color-btn" onClick={() => {upgradePlan('Professional', 'Monthly')}}>
                                                                  Start Free Trial
                                                              </button>}
                                                          {/* </Link> */}
                                                          <p className='mb-0 yearly'><span className='dollar-count'>$ 99</span> /Monthly</p>
                                                      </div>
                                                      <div className="divider">
                                                          <img src={require('../../assets/line-1.png')} alt="" />
                                                          <span className="divider-text">Main Features</span>
                                                          <img src={require('../../assets/line-1.1.png')} alt="" />
                                                      </div>
                                                      <div className="main-content">
                                                          <ul className='list-style'>
                                                              <li className='text-center'>
                                                                  <p>250 Invites/mo</p>
                                                              </li>
                                                              <li className='text-center'>
                                                                  <p>Unlimited Email credits/mo</p>
                                                              </li>
                                                              <li className='text-center'>
                                                                  <p>Automated review collection</p>
                                                              </li>
                                                              <li className='text-center'>
                                                                  <p>6 Channels</p>
                                                              </li>
                                                              <li className='text-center'>
                                                                  <p>Multi-step review campaigns</p>
                                                              </li>
                                                              <li className='text-center'>
                                                                  <p>Review widgets</p>
                                                              </li>
                                                              <li className='text-center'>
                                                                  <p>All review collection tools</p>
                                                              </li>
                                                              <li className='text-center'>
                                                                  <p>Premium support</p>
                                                              </li>
                                                          </ul>
                                                      </div>
                                                  </div>
                                              </div>
                                              <div className="col-12 col-lg-4 mb-lg-0 mb-3">
                                                  <div className="tab-card h-100">
                                                      <div className="tab-side-banner">
                                                          <p className='mb-0'>7-day FREE trial</p>
                                                      </div>
                                                      {/* </Link> */}
                                                      <div className="text-center px-lg-2">
                                                          <img src={require('../../assets/user-groups.png')} alt="" />
                                                          <p className='mb-0 start-up'>Enterprise</p>
                                                          <p className='tabcard-description'>Designed for ambitious organizations aiming to dominate their industry through accelerated review acquisition and superior reputation optimization</p>
                                                          {userData && userData.plan === 'Enterprise' && userData.subscription_type === 'Monthly' && <button className="btn color-btn active-plan">
                                                                  Active
                                                              </button>}
                                                             {userData && !(userData.plan === 'Enterprise' && userData.subscription_type === 'Monthly') && <button className="btn color-btn" onClick={() => {upgradePlan('Enterprise', 'Monthly')}}>
                                                                  Start Free Trial
                                                              </button>}
                                                          <p className='mb-0 yearly'><span className='dollar-count'>$ 499</span> /Monthly</p>
                                                      </div>
                                                      <div className="divider">
                                                          <img src={require('../../assets/line-1.png')} alt="" />
                                                          <span className="divider-text">Main Features</span>
                                                          <img src={require('../../assets/line-1.1.png')} alt="" />
                                                      </div>
                                                      <div className="main-content">
                                                          <ul className='list-style'>
                                                              <li className='text-center'>
                                                                  <p>Unlimited Invites/mo</p>
                                                              </li>
                                                              <li className='text-center'>
                                                                  <p>Unlimited Email credits/mo</p>
                                                              </li>
                                                              <li className='text-center'>
                                                                  <p>Automated review collection</p>
                                                              </li>
                                                              <li className='text-center'>
                                                                  <p>Unlimited Channels</p>
                                                              </li>
                                                              <li className='text-center'>
                                                                  <p>Multi-step review campaigns</p>
                                                              </li>
                                                              <li className='text-center'>
                                                                  <p>Review widgets</p>
                                                              </li>
                                                              <li className='text-center'>
                                                                  <p>All review collection tools</p>
                                                              </li>
                                                              <li className='text-center'>
                                                                  <p>Premium support</p>
                                                              </li>
                                                          </ul>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              )}
                              {activeTab === 'yearly' && (
                                  <div className="tab-pane-content">
                                    <div className="w-100">
                                      <div className="row justify-content-center">
                                          <div className="col-12 col-lg-4 mb-lg-0 mb-3" >
                                              <div className="tab-card h-100">
                                                  <div className="tab-side-banner">
                                                      <p className='mb-0'>7-day FREE trial</p>
                                                  </div>
                                                  <div className="text-center px-lg-2">
                                                      <img src={require('../../assets/user.png')} alt="" />
                                                      <p className='mb-0 start-up'>Starter</p>
                                                      <p className='tabcard-description'>Perfect for startups and small businesses aiming to build credibility and enhance their market position through customer testimonials</p>
                                                        {userData && userData.plan === 'Starter' && userData.subscription_type === 'Yearly' && <button className="btn color-btn active-plan">
                                                                  Active
                                                              </button>}
                                                             {userData && !(userData.plan === 'Starter' && userData.subscription_type === 'Yearly') && <button className="btn color-btn" onClick={() => {upgradePlan('Starter', 'Yearly')}}>
                                                                  Start Free Trial
                                                              </button>}
                                                      <p className='mb-0 yearly'><span className='dollar-count'>$ 446</span> /Yearly</p>
                                                  </div>
                                                  <div className="divider">
                                                      <img src={require('../../assets/line-1.png')} alt="" />
                                                      <span className="divider-text">Main Features</span>
                                                      <img src={require('../../assets/line-1.1.png')} alt="" />
                                                  </div>
                                                  <div className="main-content">
                                                      <ul className='list-style'>
                                                          <li className='text-center'>
                                                              <p>100 Invites/mo</p>
                                                          </li>
                                                          <li className='text-center'>
                                                              <p>Unlimited Email credits/mo</p>
                                                          </li>
                                                          <li className='text-center'>
                                                              <p>Automated review collection</p>
                                                          </li>
                                                          <li className='text-center'>
                                                              <p>3 Channels</p>
                                                          </li>
                                                          <li className='text-center'>
                                                              <p>Multi-step review campaigns</p>
                                                          </li>
                                                          <li className='text-center'>
                                                              <p>Review widgets</p>
                                                          </li>
                                                          <li className='text-center'>
                                                              <p>All review collection tools</p>
                                                          </li>
                                                          <li className='text-center'>
                                                              <p>Standard support</p>
                                                          </li>
                                                      </ul>
                                                  </div>
                                              </div>
                                          </div>
                                          <div className="col-12 col-lg-4 mb-lg-0 mb-3">
                                              <div className="tab-card second-card h-100">
                                                  <div className="tab-side-banner">
                                                      <p className='mb-0'>7-day FREE trial</p>
                                                  </div>
                                                  {/* </Link> */}
                                                  <div className="text-center px-lg-2">
                                                      <img src={require('../../assets/rocket.png')} alt="" />
                                                      <p className='mb-0 start-up'>Professional</p>
                                                      <p className='tabcard-description'>Perfect for organizations aiming to harness cutting-edge review management capabilities to drive customer loyalty and business growth</p>
                                                      {userData && userData.plan === 'Professional' && userData.subscription_type === 'Yearly' && <button className="btn color-btn active-plan">
                                                                  Active
                                                              </button>}
                                                             {userData && !(userData.plan === 'Professional' && userData.subscription_type === 'Yearly') && <button className="btn color-btn" onClick={() => {upgradePlan('Professional', 'Yearly')}}>
                                                                  Start Free Trial
                                                              </button>}
                                                      {/* </Link> */}
                                                      <p className='mb-0 yearly'><span className='dollar-count'>$ 902</span> /Yearly</p>
                                                  </div>
                                                  <div className="divider">
                                                      <img src={require('../../assets/line-1.png')} alt="" />
                                                      <span className="divider-text">Main Features</span>
                                                      <img src={require('../../assets/line-1.1.png')} alt="" />
                                                  </div>
                                                  <div className="main-content">
                                                      <ul className='list-style'>
                                                          <li className='text-center'>
                                                              <p>250 Invites/mo</p>
                                                          </li>
                                                          <li className='text-center'>
                                                              <p>Unlimited Email credits/mo</p>
                                                          </li>
                                                          <li className='text-center'>
                                                              <p>Automated review collection</p>
                                                          </li>
                                                          <li className='text-center'>
                                                              <p>6 Channels</p>
                                                          </li>
                                                          <li className='text-center'>
                                                              <p>Multi-step review campaigns</p>
                                                          </li>
                                                          <li className='text-center'>
                                                              <p>Review widgets</p>
                                                          </li>
                                                          <li className='text-center'>
                                                              <p>All review collection tools</p>
                                                          </li>
                                                          <li className='text-center'>
                                                              <p>Premium support</p>
                                                          </li>
                                                      </ul>
                                                  </div>
                                              </div>
                                          </div>
                                          <div className="col-12 col-lg-4 mb-lg-0 mb-3">
                                              <div className="tab-card h-100">
                                                  <div className="tab-side-banner">
                                                      <p className='mb-0'>7-day FREE trial</p>
                                                  </div>
                                                  {/* </Link> */}
                                                  <div className="text-center px-lg-2">
                                                      <img src={require('../../assets/user-groups.png')} alt="" />
                                                      <p className='mb-0 start-up'>Enterprise</p>
                                                      <p className='tabcard-description'>Designed for ambitious organizations aiming to dominate their industry through accelerated review acquisition and superior reputation optimization</p>
                                                      {userData && userData.plan === 'Enterprise' && userData.subscription_type === 'Yearly' && <button className="btn color-btn active-plan">
                                                                  Active
                                                              </button>}
                                                             {userData && !(userData.plan === 'Enterprise' && userData.subscription_type === 'Yearly') && <button className="btn color-btn" onClick={() => {upgradePlan('Enterprise', 'Yearly')}}>
                                                                  Start Free Trial
                                                              </button>}
                                                      <p className='mb-0 yearly'><span className='dollar-count'>$ 4550</span> /Yearly</p>
                                                  </div>
                                                  <div className="divider">
                                                      <img src={require('../../assets/line-1.png')} alt="" />
                                                      <span className="divider-text">Main Features</span>
                                                      <img src={require('../../assets/line-1.1.png')} alt="" />
                                                  </div>
                                                  <div className="main-content">
                                                      <ul className='list-style'>
                                                          <li className='text-center'>
                                                              <p>Unlimited Invites/mo</p>
                                                          </li>
                                                          <li className='text-center'>
                                                              <p>Unlimited Email credits/mo</p>
                                                          </li>
                                                          <li className='text-center'>
                                                              <p>Automated review collection</p>
                                                          </li>
                                                          <li className='text-center'>
                                                              <p>Unlimited Channels</p>
                                                          </li>
                                                          <li className='text-center'>
                                                              <p>Multi-step review campaigns</p>
                                                          </li>
                                                          <li className='text-center'>
                                                              <p>Review widgets</p>
                                                          </li>
                                                          <li className='text-center'>
                                                              <p>All review collection tools</p>
                                                          </li>
                                                          <li className='text-center'>
                                                              <p>Premium support</p>
                                                          </li>
                                                      </ul>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              )}

                          </div>
                  </div>
              </section>
              </div>
          </div>}
      </div>
    </div > 
    )
}

export default ChangeMembership